<template>
  <div class="caseinfo">
    <el-collapse accordion v-model="activeName" @change="handleChange">
      <el-collapse-item title="案件材料" name="2">
        <div class="caseinfo_body">
          <div class="upload-item">
            <div class="upload-title">
              <p>申请人/代理人举证</p>
              <!--  && comdata.mediatorself" -->
              <span
                class="download"
                v-if="lawAttachListAppl.length > 0"
                @click="
                  handleAlldownload('APPLICANT', '申请人和代理人举证.zip')
                "
                >一键下载</span
              >
            </div>
            <div class="upload-border">
              <el-row>
                <el-col :span="8">
                  <span>证据类型</span>
                </el-col>
                <el-col :span="7">
                  <span>证据名称</span>
                </el-col>
                <el-col :span="9">
                  <span>操作</span>
                </el-col>
              </el-row>
            </div>
            <div class="upload-border">
              <div
                v-for="item in lawAttachListAppl"
                :key="item.index"
                type="flex"
                class="row-bg"
                justify="space-between"
              >
                <el-row>
                  <el-col :span="8">
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="`上传者：${item.createUser}`"
                      placement="top"
                    >
                      <span
                        class="upload_img"
                        v-if="item.categoryMiddle === 'DOCUMENT_MATERIAL'"
                        >文书材料({{ item.createUser }})</span
                      >
                      <span
                        class="upload_img"
                        v-else-if="item.categoryMiddle === 'EVIDENCE_INVENTORY'"
                        >证据清单({{ item.createUser }})</span
                      >
                      <span
                        class="upload_img"
                        v-else-if="
                          item.categoryMiddle === 'IDENTITY_CERTIFICATE'
                        "
                        >身份证明({{ item.createUser }})</span
                      >
                      <span
                        class="upload_img"
                        v-else-if="item.categoryMiddle === 'OTHER'"
                        >其他({{ item.createUser }})</span
                      >
                      <span class="upload_img" v-else
                        >{{ item.categoryMiddle }}({{ item.createUser }})</span
                      >
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="item.proofAttachment"
                      placement="top"
                    >
                      <span class="upload_img">{{ item.proofAttachment }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="9" style="text-align: right">
                    <span
                      v-if="
                        comdata.roleType !== 'INVITATION_WATCHER' &&
                        comdata.roleType !== 'INVITATION_WATCHER2'
                      "
                      style="
                        padding: 6px;
                        color: #0083c8;
                        font-size: 12px;
                        cursor: pointer;
                      "
                      @click="crossExamination(item)"
                      >质证</span
                    >
                    <el-button
                      type="text"
                      icon="el-icon-download"
                      @click="downfile('APPLICANT', item)"
                      circle
                    ></el-button>
                    <el-button
                      v-if="
                        comdata.mediatorself || comdata.userID == item.creatorId
                      "
                      type="text"
                      icon="el-icon-delete"
                      circle
                      @click="deleteMyFile(item)"
                      :loading="BtnLoading"
                    ></el-button>
                    <el-button
                      icon="el-icon-view"
                      circle
                      style="color: #0083c8"
                      v-if="item.proofAttachment"
                      @click="viewfile(item)"
                    >
                    </el-button>
                  </el-col>
                </el-row>
              </div>
              <p v-if="!lawAttachListAppl.length">暂无材料</p>
            </div>
          </div>
          <div class="upload-item">
            <div class="upload-title">
              <p>被申请人/代理人举证</p>
              <span
                class="download"
                v-if="lawAttachListResl.length > 0"
                @click="
                  handleAlldownload('RESPONDENT', '被申请人和代理人举证.zip')
                "
                >一键下载</span
              >
            </div>
            <div class="upload-border">
              <el-row>
                <el-col :span="8">
                  <span>证据类型</span>
                </el-col>
                <el-col :span="7">
                  <span>证据名称</span>
                </el-col>
                <el-col :span="9">
                  <span>操作</span>
                </el-col>
              </el-row>
            </div>
            <div class="upload-border">
              <div
                v-for="item in lawAttachListResl"
                :key="item.index"
                type="flex"
                class="row-bg"
                justify="space-between"
              >
                <el-row>
                  <el-col :span="8">
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="`上传者：${item.createUser}`"
                      placement="top"
                    >
                      <span
                        class="upload_img"
                        v-if="item.categoryMiddle === 'DOCUMENT_MATERIAL'"
                        >文书材料({{ item.createUser }})</span
                      >
                      <span
                        class="upload_img"
                        v-else-if="item.categoryMiddle === 'EVIDENCE_INVENTORY'"
                        >证据清单({{ item.createUser }})</span
                      >
                      <span
                        class="upload_img"
                        v-else-if="
                          item.categoryMiddle === 'IDENTITY_CERTIFICATE'
                        "
                        >身份证明({{ item.createUser }})</span
                      >
                      <span
                        class="upload_img"
                        v-else-if="item.categoryMiddle === 'OTHER'"
                        >其他({{ item.createUser }})</span
                      >
                      <span class="upload_img" v-else
                        >{{ item.categoryMiddle }}({{ item.createUser }})</span
                      >
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="item.proofAttachment"
                      placement="top"
                    >
                      <span class="upload_img">{{ item.proofAttachment }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="9" style="text-align: right">
                    <span
                      v-if="
                        comdata.roleType !== 'INVITATION_WATCHER' &&
                        comdata.roleType !== 'INVITATION_WATCHER2'
                      "
                      style="
                        padding: 6px;
                        color: #0083c8;
                        font-size: 12px;
                        cursor: pointer;
                      "
                      @click="crossExamination(item)"
                      >质证</span
                    >
                    <el-button
                      type="text"
                      icon="el-icon-download"
                      @click="downfile('RESPONDENT', item)"
                      circle
                    ></el-button>
                    <el-button
                      v-if="
                        comdata.mediatorself || comdata.userID == item.creatorId
                      "
                      type="text"
                      icon="el-icon-delete"
                      circle
                      @click="deleteMyFile(item)"
                      :loading="BtnLoading"
                    ></el-button>
                    <el-button
                      icon="el-icon-view"
                      circle
                      style="color: #0083c8"
                      v-if="item.proofAttachment"
                      @click="viewfile(item)"
                    >
                    </el-button>
                  </el-col>
                </el-row>
              </div>
              <p v-if="!lawAttachListResl.length">暂无材料</p>
            </div>
          </div>
          <div class="upload-item">
            <div class="upload-title">
              <p>仲裁员材料</p>
              <span
                class="download"
                v-if="lawAttachListMedial.length > 0"
                @click="handleAlldownload('MEDIATOR', '仲裁员举证.zip')"
                >一键下载</span
              >
            </div>
            <div class="upload-border">
              <el-row>
                <el-col :span="8">
                  <span>证据类型</span>
                </el-col>
                <el-col :span="7">
                  <span>证据名称</span>
                </el-col>
                <el-col :span="9">
                  <span>操作</span>
                </el-col>
              </el-row>
            </div>
            <div class="upload-border">
              <div
                v-for="item in lawAttachListMedial"
                :key="item.index"
                type="flex"
                class="row-bg"
                justify="space-between"
              >
                <el-row>
                  <el-col :span="8">
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="`上传者：${item.createUser}`"
                      placement="top"
                    >
                      <span
                        class="upload_img"
                        v-if="item.categoryMiddle === 'DOCUMENT_MATERIAL'"
                        >文书材料({{ item.createUser }})</span
                      >
                      <span
                        class="upload_img"
                        v-else-if="item.categoryMiddle === 'EVIDENCE_INVENTORY'"
                        >证据清单({{ item.createUser }})</span
                      >
                      <span
                        class="upload_img"
                        v-else-if="
                          item.categoryMiddle === 'IDENTITY_CERTIFICATE'
                        "
                        >身份证明({{ item.createUser }})</span
                      >
                      <span
                        class="upload_img"
                        v-else-if="item.categoryMiddle === 'OTHER'"
                        >其他({{ item.createUser }})</span
                      >
                      <span class="upload_img" v-else
                        >{{ item.categoryMiddle }}({{ item.createUser }})</span
                      >
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="item.proofAttachment"
                      placement="top"
                    >
                      <span class="upload_img">{{ item.proofAttachment }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="9" style="text-align: right">
                    <span
                      v-if="
                        comdata.roleType !== 'INVITATION_WATCHER' &&
                        comdata.roleType !== 'INVITATION_WATCHER2'
                      "
                      style="
                        padding: 6px;
                        color: #0083c8;
                        font-size: 12px;
                        cursor: pointer;
                      "
                      @click="crossExamination(item)"
                      >质证</span
                    >
                    <el-button
                      type="text"
                      icon="el-icon-download"
                      @click="downfile('MEDIATOR', item)"
                      circle
                    ></el-button>
                    <el-button
                      v-if="
                        comdata.mediatorself || comdata.userID == item.creatorId
                      "
                      type="text"
                      icon="el-icon-delete"
                      circle
                      @click="deleteMyFile(item)"
                      :loading="BtnLoading"
                    ></el-button>
                    <el-button
                      icon="el-icon-view"
                      circle
                      style="color: #0083c8"
                      v-if="item.proofAttachment"
                      @click="viewfile(item)"
                    >
                    </el-button>
                  </el-col>
                </el-row>
              </div>
              <p v-if="!lawAttachListMedial.length">暂无材料</p>
            </div>
          </div>
        </div>
        <el-dialog
          :visible.sync="dialogCaseinfoImg"
          width="50%"
          title="证据目录"
          custom-class="dialog-caseinfo"
          :before-close="handleClose"
        >
          <el-container>
            <el-main>
              <filePreview
                :file-list="detailBean"
                :show-delte="detailBean.allowDel"
                @detelEvidenceFile="detelEvidenceFile"
                @close="close"
              ></filePreview>
            </el-main>
          </el-container>
        </el-dialog>
        <crossExamination
          ref="crossExamination"
          v-if="createRoomData"
          :comdata="comdata"
        ></crossExamination>
      </el-collapse-item>
      <el-collapse-item title="签名材料" name="4">
        <div class="caseinfo_body">
          <div class="upload-item">
            <div class="upload-border">
              <div
                v-for="item in recordAttaList"
                :key="item.index"
                type="flex"
                class="row-bg"
                justify="space-between"
              >
                <el-row
                  v-if="
                    !(
                      item.sign === 'SEND_RECEIPT' &&
                      comdata.roleType === 'OTHER'
                    )
                  "
                >
                  <el-col :span="18">
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="item.fileName"
                      placement="top"
                    >
                      <span class="upload_img">{{ item.fileName }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="2"
                    ><el-button
                      type="text"
                      icon="el-icon-download"
                      @click="downRecordFile(item)"
                      circle
                    ></el-button
                  ></el-col>
                  <div
                    v-if="
                      item.docOpinionList !== null &&
                      item.sign === 'MEDIATION_RECORD'
                    "
                  >
                    <el-col :span="4"
                      ><el-button
                        v-if="item.docOpinionList.length !== 0"
                        type="text"
                        @click="downRecordAdvice(item.docOpinionList)"
                        circle
                        >笔录意见</el-button
                      ></el-col
                    >
                  </div>
                </el-row>
              </div>
              <p v-if="!recordAttaList.length">暂无材料</p>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="
          comdata.roleType !== 'INVITATION_WATCHER' &&
          comdata.roleType !== 'INVITATION_WATCHER2'
        "
        title="材料上传"
        name="3"
      >
        <div class="caseinfo_body">
          <el-form
            :model="ruleFormUpload"
            :rules="rulesupload"
            ref="ruleFormUpload"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item
              v-if="comdata.roleType == 'MEDIATOR'"
              label="上传栏目"
              prop="typerole"
            >
              <el-select
                v-model="ruleFormUpload.typerole"
                placeholder="请选择"
                class="widthmax"
              >
                <el-option
                  v-for="item in ruleFormUpload.typeroleoptions"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分类" prop="typevalue">
              <el-select
                v-model="ruleFormUpload.typevalue"
                placeholder="请选择"
                class="widthmax"
              >
                <el-option
                  v-for="item in ruleFormUpload.typeoptions"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-upload
                class="upload-demo list-uploadbtn"
                ref="upload"
                :action="curBastUrl"
                :headers="flk"
                :data="filedata"
                :on-preview="handlePreview"
                :on-success="updataSuccess"
                :on-remove="updataRemove"
                :on-error="updataerror"
                :on-change="updatachange"
                :accept="acceptType"
                :file-list="fileList"
                :before-upload="handleBefore"
                :multiple="true"
              >
                <el-button
                  class="meeting_button_default"
                  size="small"
                  type="primary"
                  >选择文件</el-button
                >
                <div slot="tip" class="el-upload__tip">
                  提示：只能上传pdf/doc/docx/png/jpg文件，{{ maxFileTip }}
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              type="primary"
              class="meeting_button_primary"
              :loading="BtnLoading"
              @click="saveUpFilesMeeting"
              :disabled="updatabtn"
              >保 存</el-button
            >
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog
      title="笔录当事人意见"
      :visible.sync="dialogRecordAdv"
      width="50%"
      :before-close="handleCloseRecordAdv"
      center
    >
      <div class="record-message_list" ref="dialogRecordBox" id="dialogBox">
        <ul>
          <li v-for="msg in RecordAdvmsgs" :key="msg.index">
            <span>[{{ msg.userName }}] {{ timestoday(msg.timeStamp) }}</span>
            <div class="infobackground">
              <div class="">{{ msg.docOpinion }}</div>
            </div>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogRecordAdv = false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import disputeRemark from '@/publicResource/api/disputeRemark.js'
import filedownload from "@/utils/filedown.js";
import crossExamination from "@/views/meeting/components/crossExamination";
import { setStore, getStore, removeStore } from "@/utils/utils.js";
import {
  refreshToken,
  getMeetingDetail,
  getMaterailInfo,
  saveEnvCaseMaterial,
  delEnvCaseMaterial,
  clerkRecordAttaList,
  createRoom,
  batchDownLoad,
} from "@/api/meeting.js";
import { ERR_OK } from "@/api/reConfig";
import config from "@/config/config.js";
import {
  batchFilesUpload,
  materialType,
  getMediatorDocuments,
} from "@/api/meeting";
import {
  maxFileLength,
  maxFileWarning,
  maxFileTip,
} from "../../../utils/utils";
import filePreview from "../../caseSpace/components/FilePreviewLIst.vue";
import { delEvidenceDetails } from "@/api/user.js";

export default {
  components: {
    crossExamination,
    filePreview,
  },
  model: {
    prop: "comdata",
    event: "callbackarea",
  },
  data() {
    return {
      BtnLoading: false,
      dialogVisible: false,
      maxFileTip: maxFileTip,
      dialogType: "",
      diatorTitle: "",
      activeName: "1",
      mediators: [],
      applicantList: [],
      respondentList: [],
      detailcaseinfo: {},
      uploadDocumentsList: [],
      detailBean: {},
      documents: {
        idCard: [],
        surveyReport: [],
        notice: [],
        lawsuit: [],
        other: [],
      },
      lawAttachList: [], //文书材料列表全部
      lawAttachListAppl: [],
      lawAttachListResl: [],
      lawAttachListMedial: [],
      dataload: false,
      ruleFormUpload: {
        typeoptions: [
          {
            code:"OTHER",
            name: "其他",
          },
          {
            code:"DOCUMENT_MATERIAL",
            name: "文书材料",
          },
          {
            code:"EVIDENCE_INVENTORY",
            name: "证据清单",
          },
          {
            code:"IDENTITY_CERTIFICATE",
            name: "身份证明",
          },
        ],
        typevalue: "",
        typeroleoptions: [
          {
            name: "申请人",
            code: "APPLICANT",
          },
          {
            name: "被申请人",
            code: "RESPONDENT",
          },
          {
            name: "仲裁员",
            code: "MEDIATOR",
          },
          {
            name: "其他人",
            code: "OTHER",
          },
        ],
        typerole: "APPLICANT",
        nameoptions: [],
        namevalue: "",
      },
      material: {},
      rulesupload: {
        typerole: [
          { required: true, message: "请选择角色", trigger: "change" },
        ],
        typevalue: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
        namevalue: [
          { required: true, message: "请选择材料名称", trigger: "blur" },
        ],
      },
      acceptType: ".pdf,.doc,.docx,.png,.jpg",
      curBastUrl: `${config.baseURL}/basicGateway/file/upload`,
      flk: {
        JWTToken: this.comdata.invite
          ? getStore("otherToken")
          : getStore("flk"),
        appName: "gzzc",
        cType: "PC",
      },
      filedata: { isView: "VIEW" },
      caseFileid: "",
      updatabtn: true,
      caseinfoid: [],
      materialname: true,
      fileList: [],
      caseId: "",
      dataloaded: false,
      curDisputeRemark: "",
      curDisputeName: "",
      meetingSingleId: 0,
      caseSingleId: 0,
      recordAttaList: [],
      allFileList: [],
      caseinfoImg: "",
      dialogCaseinfoImg: false,
      addEvidenceData: {},
      createRoomData: {},
      dialogRecordAdv: false,
      RecordAdvmsgs: [], //笔录意见
    };
  },
  props: [
    "comdata",
    "curCaseDetail",
    "documentsList",
    "insideInfoCaseId",
    "singleMeetingId",
    "wselement",
  ],
  mounted() {
    this.getMaterailInfo();
  },
  watch: {
    curCaseDetail: function (newData, oldData) {
      this.mediators = newData.mediators;
      this.applicantList = newData.applicants;
      this.respondentList = newData.respondents;
      this.detailcaseinfo.disputeType = newData.disputeType;
      this.detailcaseinfo.disputeContent = newData.disputeContent;
      this.detailcaseinfo.appeal = newData.appeal;
      this.detailcaseinfo.provName = newData.provName;
      this.detailcaseinfo.provCode = newData.provCode;
      this.detailcaseinfo.cityName = newData.cityName;
      this.detailcaseinfo.cityCode = newData.cityCode;
      this.detailcaseinfo.areaName = newData.areaName;
      this.detailcaseinfo.areaCode = newData.areaCode;
      this.detailcaseinfo.streetName = newData.streetName;
      this.detailcaseinfo.streetCode = newData.streetCode;
      this.detailcaseinfo.communityName = newData.communityName;
      this.detailcaseinfo.communityCode = newData.communityCode;
      this.detailcaseinfo.address = newData.address;
      // this.curDisputeRemark = disputeRemark[newData.disputeTypeCode].remark;
      // this.curDisputeName = disputeRemark[newData.disputeTypeCode].name

      // this.uploadList(newData.documents)
    },
    documentsList: function (newData, oldData) {
      this.uploadDocumentsList = newData;
    },
    comdata: {
      handler: function (newData, oldData) {
        let self = this;
        self.$nextTick(function () {
          this.caseId = newData.caseID;
        });
      },
    },
  },
  methods: {
    //  获取材料分类
    getMaterailInfo() {
      getMaterailInfo(
        {
          parentCode: "HZ_CASE_MATERIAL_TYPE",
          //parentCode: "MEDIATE_MATERIAL_TYPE",
        },
        this.comdata.invite
      ).then(
        (res) => {
          console.log(res,111111111)
          if (res.data.code == ERR_OK) {
            //this.ruleFormUpload.typeoptions = res.data.data;
          }
        },
        (erro) => {}
      );
    },
    openDialog(caseid, meetingId) {
      this.caseSingleId = caseid;
      this.meetingSingleId = meetingId;
      //获取笔录材料
      clerkRecordAttaList(
        {
          objectId: meetingId,
          objectType: "MEDIATION",
        },
        this.comdata.invite
      ).then(
        (res) => {
          this.recordAttaList = res.data.data;
        },
        (erro) => {}
      );

      this.getMeetingDetail(caseid, meetingId);

      if (this.dataloaded) return;
      if (!this.comdata.istemporary) {
        materialType({ lawCaseId: caseid }).then((res) => {
          console.log(res,'2222222')
          if (res.data.code === 1000) {
            //this.ruleFormUpload.typeoptions = res.data.data.materialTypes;
            this.material = res.data.data.materialSubTypes;
            this.ruleFormUpload.nameoptions =
              res.data.data.materialSubTypes["IDENTITY_CERTIFICATE"];
            this.dataloaded = true;
          }
        });
      }
    },
    getMeetingDetail(caseid, meetingId) {
      let params = {
        caseId: caseid ? caseid : "",
        meetingId: meetingId,
      };
      getMeetingDetail(params, this.comdata.invite).then(
        (res) => {
          console.log(res, "=======================");
          if (res.data.code == ERR_OK) {
            this.lawAttachList = res.data.data.lawAttachList;
            (this.lawAttachListAppl = []), //申请人代理人举证
              (this.lawAttachListResl = []), //被申请人及代理人举证
              (this.lawAttachListMedial = []); //仲裁院资料
            this.lawAttachList.forEach((item) => {
              if (
                item.categorySmall === "APPLICANT" ||
                item.categorySmall === "APPLICANT_AGENT"
              ) {
                if (item.proofAttachment !== "") {
                  this.lawAttachListAppl.push(item);
                } else {
                  return;
                }
              } else if (
                item.categorySmall === "RESPONDENT" ||
                item.categorySmall === "RESPONDENT_AGENT"
              ) {
                if (item.proofAttachment !== "") {
                  this.lawAttachListResl.push(item);
                }
              } else {
                if (item.proofAttachment !== "") {
                  this.lawAttachListMedial.push(item);
                }
              }
            });
            this.uploadList(res.data.data);
          }
        },
        (erro) => {}
      );
    },
    handleAlldownload(type, fileName) {
      console.log(type, fileName);
      let fileIds = [];
      if (type == "APPLICANT") {
        this.lawAttachListAppl.forEach((element) => {
          fileIds.push(element.id);
          console.log(fileIds);
        });
      } else if (type == "RESPONDENT") {
        this.lawAttachListResl.forEach((element) => {
          fileIds.push(element.id);
          console.log(fileIds);
        });
      } else if (type == "MEDIATOR") {
        this.lawAttachListMedial.forEach((element) => {
          fileIds.push(element.id);
          console.log(fileIds);
        });
      }
      filedownload(
        "/gzzc/docBook/batchDownLoad",
        {
          ids: fileIds,
          caseId: this.$route.query.caseid,
        },
        fileName
      );
    },
    handleChange(tab) {
      if (tab == "3") {
        this.ruleFormUpload.nameoptions = this.material["IDENTITY_CERTIFICATE"];
        return true;
      }
    },
    handleBefore(file) {
      if (file.size > maxFileLength) {
        this.$message.error(maxFileWarning);
        return false;
      } else {
        // 再次校验文件类型
        let fileType = file.name.split(".").pop();
        if (this.acceptType.search(fileType) == -1) {
          this.$message.error("请上传pdf/doc/docx/png/jpg格式的文件");
          return false;
        } else {
          return true;
        }
      }
    },
    uploadList(list) {
      (this.documents.idCard = []),
        (this.documents.surveyReport = []),
        (this.documents.notice = []),
        (this.documents.lawsuit = []),
        (this.documents.other = []);
      if (list.lawAttachList && list.lawAttachList.length) {
        list.lawAttachList.forEach((item) => {
          if (item.categoryMiddle == "DOCUMENT_MATERIAL") {
            this.documents.surveyReport.push(item);
          } else if (item.categoryMiddle == "EVIDENCE_INVENTORY") {
            this.documents.lawsuit.push(item);
          } else if (item.categoryMiddle == "IDENTITY_CERTIFICATE") {
            this.documents.idCard.push(item);
          } else {
            this.documents.other.push(item);
          }
        });
      }
    },
    materialTypeChange(val) {
      if (!Boolean(this.material[val]) || this.material[val].length == 0) {
        this.materialname = false;
        // this.ruleFormUpload.namevalue = val
      } else {
        this.ruleFormUpload.namevalue = this.material[val][0].code;
        this.materialname = true;
        this.ruleFormUpload.nameoptions = this.material[val];
      }
    },
    timestoday(t) {
      var times = new Date(t);
      var ty = times.getFullYear(),
        tm = times.getMonth() + 1,
        td = times.getDate(),
        th = times.getHours(),
        tmt = times.getMinutes(),
        ts = times.getSeconds();
      var ntostring = function (d) {
        if (d.toString().length == 1) {
          return "0" + d;
        }
        return d;
      };
      return ntostring(th) + ":" + ntostring(tmt) + ":" + ntostring(ts);
    },
    updataSuccess(response, file, fileList) {
      //上传后更新
      if (response.code === 1000) {
        this.caseFileid = response.data.fileId;
        this.fileList = fileList;
        this.updatabtn = false;
      } else if (response.code === 1002) {
        refreshToken({
          refreshToken: getStore("refreshToken"),
        }).then((res) => {
          let data = res.data;
          if (data.code === 1000) {
            setStore("flk", data.data.flk);
            setStore("refreshToken", data.data.refreshToken);
            //修改原请求的token
            this.flk = {
              JWTToken: data.data.flk,
              appName: "gzzc",
              cType: "PC",
            };
            this.$message({ message: "请重新上传文件", type: "error" });
          } else {
            removeStore("username");
            removeStore("flk");
            removeStore("refreshToken");
            removeStore("phone");
            removeStore("roles");
            router.push({ path: "/" });
          }
        });
        this.$refs.upload.clearFiles();
      } else if (response.code === 1001) {
        removeStore("loginInfo");
        removeStore("flk");
        removeStore("refreshToken");
        this.$router.push({
          path: "/login",
        });
      } else {
        this.$refs.upload.clearFiles();
      }
    },
    updataerror(err, file, fileList) {
      this.updatabtn = false;
    },
    handlePreview(file) {},
    updatachange(file, fileList) {
      // this.fileList = fileList
      // if (fileList.length > 0) {
      //     this.updatabtn = false
      // } else {
      //     this.updatabtn = true
      // }
    },
    updataRemove(file, fileList) {
      this.fileList = fileList;
      if (fileList.length > 0) {
        this.updatabtn = false;
      } else {
        this.updatabtn = true;
      }
    },
    saveUpFilesMeeting() {
      this.updatabtn = true;
      this.BtnLoading = true;
      let fileJson = [];
      fileJson = this.fileList.map((item) => {
        return {
          fileId: item.response.data.fileId,
          fileName: item.name,
          categoryMiddle: this.ruleFormUpload.typevalue,
          sign: this.ruleFormUpload.typevalue,
        };
      });
      saveEnvCaseMaterial(
        {
          categorySmall:
            this.comdata.roleType !== "MEDIATOR"
              ? JSON.parse(getStore("loginInfo")).memberType
              : this.ruleFormUpload.typerole,
          caseId: this.insideInfoCaseId,
          categoryMiddle: this.ruleFormUpload.typevalue,
          files: fileJson,
          sign: this.ruleFormUpload.typevalue,
          meetingId: this.meetingSingleId,
        },
        this.comdata.invite
      ).then(
        (res) => {
          if (res.data.code == 1000) {
            this.getMeetingDetail(this.caseSingleId, this.meetingSingleId);
            this.activeName = "2";
            this.wselement.send(
              JSON.stringify({
                event: "OTHER",
                data: { event: "SEND_MATERIAL", roomId: this.comdata.roomID },
              })
            );
            this.$message({ message: "保存成功", type: "success" });
            this.fileList = [];
          } else {
            this.$message({
              message: "更新上传文件出错，请重新上传",
              type: "error",
            });
          }
          this.BtnLoading = false;
          this.updatabtn = false;
          this.caseFileid = "";
          this.$refs.upload.clearFiles();
        },
        (erro) => {
          this.BtnLoading = false;
          this.updatabtn = false;
        }
      );
    },
    updataFilesList(file) {
      //接收上传弹窗回传值
      let documentObject = file;
      documentObject.forEach((item, index, array) => {
        item.documentUser = this.comdata.selfName;
        item.userId = this.comdata.userID;
        if (item.documentType == "IDENTITY_CERTIFICATE") {
          this.documents.idCard.push(item);
        } else if (item.documentType == "EVIDENCE_INVENTORY") {
          this.documents.evidence.push(item);
        } else if (item.documentType == "DOCUMENT_MATERIAL") {
          this.documents.material.push(item);
        } else {
          this.documents.other.push(item);
        }
      });
      this.activeName = "2";
    },
    downfile(type, item) {
      // console.log(this.comdata.mediatorself,this.comdata.userID)
      // console.log(item);
      let fileName = "";
      console.log(fileName);
      if (type === "APPLICANT") {
        fileName = "申请人/代理人举证.zip";
      } else if (type == "RESPONDENT") {
        fileName = "被申请人/代理人举证.zip";
      } else if (type == "MEDIATOR") {
        fileName = "仲裁员举证.zip";
      }
      filedownload(
        "/gzzc/docBook/batchDownLoad",
        {
          ids: item.id,
          caseId: this.$route.query.caseid,
        },
        fileName
      );

    },
    viewfile(item) {
      this.dialogCaseinfoImg = true;
      this.detailBean = item;
    },
    handleClose() {
      this.dialogCaseinfoImg = false;
    },
    downRecordFile(item) {
      filedownload(
        "/gzzc/clerkRecord/getClerkRecordMaterial",
        {
          id: item.id,
        },
        item.fileName
      );
    },
    downRecordAdvice(list) {
      //笔录意见
      this.dialogRecordAdv = true;
      this.RecordAdvmsgs = list;
    },
    deleteMyFile(file) {
      let self = this;
      self
        .$alert(
          '<h4 class="title_red">温馨提示</h4><div>是否继续删除该文件?</div>',
          "温馨提示",
          {
            dangerouslyUseHTMLString: true,
            showCancelButton: true,
            confirmButtonText: "确定",
            confirmButtonClass: "meeting_button_primary_small",
            cancelButtonClass: "meeting_button_default_small",
            cancelButtonText: "取消",
            customClass: "alert_record",
          }
        )
        .then(() => {
          self.BtnLoading = true;
          delEnvCaseMaterial(
            {
              id: file.id,
              caseId: this.comdata.caseID ? this.comdata.caseID : "",
              fileId: file.fileId,
              meetingId: this.meetingSingleId,
            },
            this.comdata.invite
          ).then((res) => {
            if (res.data.code === 1000) {
              // self.deleteFilesList(file)
              this.getMeetingDetail(this.caseSingleId, this.meetingSingleId);
              this.wselement.send(
                JSON.stringify({
                  event: "OTHER",
                  data: { event: "SEND_MATERIAL", roomId: this.comdata.roomID },
                })
              );
            } else {
              this.$message.error(res.data.message);
            }
            self.BtnLoading = false;
          });
        });
    },
    deleteFilesList(file) {
      if (file.categoryMiddle == "IDENTITY_CERTIFICATE") {
        this.documents.idCard.forEach((item, index, array) => {
          if (item.id == file.id) {
            array.splice(index, 1);
          }
          this.documents.idCard = array;
        });
      } else if (file.categoryMiddle == "DOCUMENT_MATERIAL") {
        this.documents.surveyReport.forEach((item, index, array) => {
          if (item.id == file.id) {
            array.splice(index, 1);
          }
          this.documents.surveyReport = array;
        });
      } else if (file.categoryMiddle == "EVIDENCE_INVENTORY") {
        this.documents.lawsuit.forEach((item, index, array) => {
          if (item.id == file.id) {
            array.splice(index, 1);
          }
          this.documents.lawsuit = array;
        });
      } else {
        this.documents.other.forEach((item, index, array) => {
          if (item.id == file.id) {
            array.splice(index, 1);
          }
          this.documents.other = array;
        });
      }
    },
    crossExamination(item) {
      let addEvidence = {
        attachmentId: item.id,
        caseId: this.comdata.caseID,
        meetingId: this.meetingSingleId,
      };
      this.addEvidenceData = addEvidence;
      //提交质证
      createRoom({
        attachmentId: item.id,
        caseId: this.comdata.caseID,
        meetingId: this.meetingSingleId,
      }).then((res) => {
        if (res.data.code === 1000) {
          this.$refs.crossExamination.dialogVisible = true;
          this.createRoomData = res.data.data;
          if (this.createRoomData.roomId) {
            this.$refs.crossExamination.handleGetSelectvalue(
              this.createRoomData,
              this.addEvidenceData,
              item
            );
            this.$refs.crossExamination.enterRoom(this.createRoomData.roomId);
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleCloseRecordAdv() {
      this.dialogRecordAdv = false;
    },
    detelEvidenceFile(item) {
      delEvidenceDetails({
        id: item.id,
        fileId: item.fileId,
      }).then((res) => {
        this.getMeetingDetail(this.caseSingleId, this.meetingSingleId);
        if (res.code === 1000) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
        }
      });
    },
    close() {
      this.dialogCaseinfoImg = false;
    },
  },
};
</script>

<style lang="scss">
.el-tooltip__popper {
  max-width: 40% !important; //宽度可根据自己需要进行设置
}
.caseinfo {
  padding: 10px 20px;
  .el-col {
    text-align: center;
  }
  .el-collapse {
    border: none;
  }
  .el-collapse-item {
    margin-bottom: 15px;
    border: 1px solid #f4f4f4;
  }
  .el-collapse-item__header {
    height: 40px;
    padding-left: 15px;
    line-height: 40px;
    font-size: 14px;
  }
  .el-collapse-item__arrow {
    line-height: 40px;
    font-weight: 600;
  }
  .caseinfo_wrap {
    margin-bottom: 10px;
    .item {
      padding: 10px 2px;
      border: 1px solid #efefef;
      border-radius: 4px;
    }
    h4 {
      padding: 5px 10px;
      font-weight: bold;
    }
    h5 {
      padding: 5px 10px;
    }
    span {
      display: inline-block;
      padding: 0 10px 5px;
    }
  }
  .caseinfo_body {
    padding: 15px;
    .dialog-footer {
      text-align: center;
    }
    .upload-item {
      position: relative;
      font-size: 14px;
      margin-bottom: 10px;
      .upload-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .download {
          color: #0083c8;
          cursor: pointer;
        }
      }
      label {
        display: block;
        width: 80px;
        color: #b2b2b2;
      }
      .upload-border {
        padding: 10px;
        line-height: 20px;
        border: 1px solid #efefef;
        border-radius: 4px;
        background-color: #fdfdfd;
        text-align: center;
      }
      .el-button.is-circle {
        padding: 6px;
      }
      .upload_img {
        display: inline-block;
        width: 100%;
        line-height: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
        // text-align: left;
      }
      .upload_user {
        display: inline-block;
        width: 100%;
        line-height: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
      }
      p {
        line-height: 28px;
      }
    }
    .el-upload__tip {
      line-height: 24px;
    }
    .widthmax {
      width: 100%;
    }
    .el-form-item__content {
      width: 230px;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
  }
  .dialog-caseinfo {
    img {
      display: block;
      width: 100%;
      height: 100%;
      // margin: 50px auto;
    }
  }
  .record-message_list {
    height: 300px;
    margin-bottom: 10px;
    padding: 20px;
    border-radius: 2px;
    border: solid 1px #e6e6e6;
    box-sizing: border-box;
    overflow-y: auto;
    li {
      padding: 10px 0 15px;
      span {
        display: block;
        padding-bottom: 6px;
        color: #888888;
        font-size: 14px;
      }
      div.infobackground {
        position: relative;
        display: inline-block;
        width: 100%;
        box-sizing: border-box;
        padding: 10px 15px;
        line-height: 22px;
        color: #494949;
        font-size: 14px;
        background-color: #f7f7f7;
        border: 1px solid #f0f0f0;
        border-radius: 2px;
        text-align: left;
        cursor: text;
        div {
          word-wrap: break-word;
        }
      }
    }
    .no_list {
      img {
        display: block;
        margin: 40px auto 0;
      }
    }
  }
}
</style>
